export { default as GraphTableSwitch } from './GraphTableSwitch';
export type {
	GraphTableData,
	GraphTableSeries,
	GraphTableSeriesStyle,
	GraphTableSwitchProps
} from './types';
